import { Component, Input, inject } from '@angular/core';
import { ForecastSeriesCompletedWithoutMeasure } from '@api-response-types/forecast-series.response';
import { Store } from '@ngrx/store';
import { ForecastAppliedFiltersComponent } from 'demand-forecasting/components/forecast-detail/forecast-applied-filters/forecast-applied-filters.component';
import {
  ClickedPredictionPoint,
  ForecastChartComponent,
} from 'demand-forecasting/components/forecast-detail/forecast-chart/forecast-chart.component';
import { ForecastFeatureImportanceComponent } from 'demand-forecasting/components/forecast-detail/forecast-feature-importance/forecast-feature-importance.component';
import { ForecastKpisComponent } from 'demand-forecasting/components/forecast-detail/forecast-kpis/forecast-kpis.component';
import { ForecastPredictionExplanationComponent } from 'demand-forecasting/components/forecast-detail/forecast-prediction-explanation/forecast-prediction-explanation.component';
import { SelectedFilterCombinationChipsComponent } from 'demand-forecasting/components/forecast-detail/selected-filter-combination-chips/selected-filter-combination-chips';
import { ChangeChartTimeRangeService } from 'demand-forecasting/services/chart/change-chart-time-range.service';
import { selectShowInterval } from 'demand-forecasting/store/forecast-series/forecast-series.selectors';

@Component({
  selector: 'pm-version-is-finished-result',
  templateUrl: './version-is-finished-result.component.html',
  imports: [
    ForecastChartComponent,
    ForecastAppliedFiltersComponent,
    ForecastKpisComponent,
    ForecastPredictionExplanationComponent,
    ForecastFeatureImportanceComponent,
    SelectedFilterCombinationChipsComponent,
  ],
})
export class VersionIsFinishedResultComponent {
  private readonly store = inject(Store);
  @Input({
    required: true,
  })
  forecastSeries: ForecastSeriesCompletedWithoutMeasure;
  protected changeTimeRangeService = inject(ChangeChartTimeRangeService);
  protected isIntervalEnabled = this.store.selectSignal(selectShowInterval);

  clickedDate: ClickedPredictionPoint | undefined;
  timeRangeToDisplay = 0;
  langOptions: Highcharts.LangOptions = {};

  // only necessary for what-if -> can be removed for new implementation
  resultSetId: string;

  updateSelectedTimeRange(timeRange: Highcharts.ExtremesObject): void {
    this.changeTimeRangeService.timeRange = {
      min: timeRange.min,
      max: timeRange.max,
    };
  }

  onPredictionPointClick(event: ClickedPredictionPoint | undefined) {
    this.clickedDate = event;
  }
}
